import { render } from "./ZapiInputNumber.vue?vue&type=template&id=2bf45eb2&scoped=true"
import script from "./ZapiInputNumber.vue?vue&type=script&lang=js"
export * from "./ZapiInputNumber.vue?vue&type=script&lang=js"

import "./ZapiInputNumber.vue?vue&type=style&index=0&id=2bf45eb2&scoped=true&lang=css"

import exportComponent from "C:\\laragon\\www\\frontend_zapi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bf45eb2"]])

export default __exports__